/**
 * 404 Not Found page.
 */

import { Link } from "react-router-dom";
import { FileQuestion, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-8">
      <FileQuestion className="text-muted-foreground h-16 w-16" />
      <h1 className="mt-6 text-2xl font-semibold">Page non trouvée</h1>
      <p className="text-muted-foreground mt-2 max-w-md text-center">
        La page que vous recherchez n'existe pas ou a été déplacée.
      </p>
      <Button asChild className="mt-8">
        <Link to="/">
          <ArrowLeft className="mr-2 h-4 w-4" />
          Retour à l'accueil
        </Link>
      </Button>
    </div>
  );
}
